<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <Typography>
          <Title :level="4">{{ question.title }}</Title>
          <Paragraph>{{ question.content }}</Paragraph>
          <Paragraph>提问人: <b style="margin-right: 12px;">{{ question.createUserName }}</b> 提问时间: <b style="margin-right: 12px;">{{ question.createTime }}</b> 问题状态:<b>{{ question.status }}</b></Paragraph>
        </Typography>
        <div class="question-info"> <Space wrap>
          <Button type="success" @click="questionCheck(1, question.id)">通过</Button>
          <Button type="warning" @click="questionCheck(-1, question.id)">不通过</Button>
        </Space></div>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '../../utils/global'
import axios from 'axios'
import { Paragraph } from 'view-ui-plus'
export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread,
    Paragraph
},
  data () {
    return {
      user: null,
      
      question: {},
      status: 0,
    }
  },

  mounted() {
    this.initUser()
    this.workBriefing()
  },
  methods: {
    //初始化用户信息
    initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

    workBriefing() {
      let vm = this
      let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/question/detail',
        data: {
          limit:10,
          page: vm.page,
          id: id
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.question = data.question
          vm.answers = data.answers
          vm.answerNum = data.answerNum
        }
      });
    },
    
    //问题审核
    questionCheck(status, id) {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/question/check',
        data: {
          id: id,
          status: status
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          vm.$Message.success({
            content: response.data.message,
            duration: 3,
            closable: true,
            onClose: (function() {
              vm.$router.push({path: '/admin/question/all'});
            })
          });
        }
      });
    }
  }
}
</script>
